export const about = {
  // Hero Section
  heroTitle: 'ICAN',
  heroSubtitle: '우주를 배우다, 미래를 구현하다',
  heroDescription: '아이캔은 우주적 사고를 통해 미래 핵심 역량을 키우는 혁신적인 교육 기관입니다',

  // Stats
  stat1Value: '8주',
  stat1Label: 'EDUSPACE 프로그램',
  stat2Value: '초등 4-5',
  stat2Label: '학년 맞춤 교육',
  stat3Value: '7개',
  stat3Label: '우주 탐사 주제',
  stat4Value: '100%',
  stat4Label: '실습 기반 학습',

  // Mission Section
  missionTitle: '우리의',
  missionTitleHighlight: '미션',
  missionParagraph1: '탐험하는 배움이 데이터·문제해결·디자인 역량으로 이어지도록, 아이캔은 우주적 사고로 커리큘럼을 설계합니다.',
  missionParagraph2: '우리는 단순히 지식을 전달하는 것이 아니라, 학생들이 스스로 탐구하고 발견하며 창조하는 과정을 통해 진정한 배움을 경험하도록 돕습니다. 우주라는 거대한 주제를 통해 학생들은 거시적 사고와 미시적 분석 능력을 동시에 키웁니다.',

  // Core Values Section
  valuesTitle: '핵심',
  valuesTitleHighlight: '가치',
  valuesSubtitle: '아이캔 교육 철학의 근간이 되는 4가지 핵심 가치',

  value1Title: '문제해결 중심',
  value1Description: 'EDUSPACE는 매일 실제 우주 문제를 해결하며 비판적 사고와 창의력을 키웁니다.',

  value2Title: '실습 기반 학습',
  value2Description: '직접 만들고, 실험하고, 발표하는 체험형 프로젝트로 진짜 배움이 일어납니다.',

  value3Title: '체계적 커리큘럼',
  value3Description: '월-금 매일 다른 활동으로 학습 기술, 리서치, 제작, 발표 능력을 균형있게 발전시킵니다.',

  value4Title: '초등 맞춤 교육',
  value4Description: '초등 4-5학년 발달 단계에 최적화된 난이도와 교육 방식을 제공합니다.',

  // Team Section
  teamTitle: '전문가',
  teamTitleHighlight: '팀',
  teamSubtitle: '우주와 교육 분야의 최고 전문가들',

  team1Name: 'Dr. 김우주',
  team1Role: '대표이사 / 교육 총괄',
  team1Description: '서울대학교 천문학 박사, NASA 연구원 출신',
  team1Skill1: '천문학',
  team1Skill2: '우주과학',
  team1Skill3: '교육과정 설계',

  team2Name: '이지혜',
  team2Role: '커리큘럼 디렉터',
  team2Description: 'KAIST 항공우주공학 박사, 전 NASA STEM 교육 프로그램 리더',
  team2Skill1: '항공우주공학',
  team2Skill2: '프로젝트 기반 학습',
  team2Skill3: 'STEAM 교육',

  team3Name: '박데이터',
  team3Role: '기술 이사',
  team3Description: 'MIT 데이터 사이언스 석사, 전 Google AI 연구원',
  team3Skill1: '데이터 과학',
  team3Skill2: 'AI/ML',
  team3Skill3: '위성 데이터 분석',

  team4Name: '최혁신',
  team4Role: '교육 혁신 팀장',
  team4Description: '하버드 교육학 박사, 전 국제우주대학 교수',
  team4Skill1: '교육 심리학',
  team4Skill2: '학습 과학',
  team4Skill3: '교육 기술',

  // Timeline Section
  timelineTitle: '성장',
  timelineTitleHighlight: '스토리',
  timelineSubtitle: '아이캔의 지난 5년간 여정',

  timeline1Year: '2020',
  timeline1Title: 'ICAN 설립',
  timeline1Description: '우주 교육의 새로운 패러다임 시작',

  timeline2Year: '2021',
  timeline2Title: '첫 파일럿 프로그램',
  timeline2Description: '초등학생 대상 우주 과학 교육 시작',

  timeline3Year: '2022',
  timeline3Title: 'EDUSPACE 개발',
  timeline3Description: '문제해결 중심 8주 커리큘럼 설계',

  timeline4Year: '2023',
  timeline4Title: 'EDUSPACE 정식 출시',
  timeline4Description: '초등 4-5학년 맞춤 프로그램 론칭',

  timeline5Year: '2024',
  timeline5Title: '프로그램 확장',
  timeline5Description: '7개 주제 완성, 월-금 체계적 학습 구조 확립',

  // Partners Section
  partnersTitle: '파트너 &',
  partnersTitleHighlight: '협력',
  partnersSubtitle: '글로벌 기관들과의 협력을 통한 최고 수준의 교육',

  partner1Name: 'NASA',
  partner1Description: 'STEM 교육 파트너십',

  partner2Name: 'KAIST',
  partner2Description: '공동 연구 및 교육 프로그램',

  partner3Name: 'KARI',
  partner3Description: '한국항공우주연구원 협력',

  partner4Name: 'Seoul Nat\'l Univ',
  partner4Description: '천문학과 산학 협력',

  partner5Name: 'Google',
  partner5Description: '데이터 사이언스 교육 지원',

  partner6Name: 'SpaceX',
  partner6Description: '우주 산업 인사이트 공유',

  // CTA Section
  ctaTitle: '함께',
  ctaTitleHighlight: '미래',
  ctaSubtitle: '아이캔과 함께 우주적 사고의 여정을 시작하세요',
  ctaButton1: '상담 신청하기',
  ctaButton2: '커리큘럼 보기'
};
